<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm01_halftit"></a><a id="page_i"></a>T<span class="small">HE</span> M<span class="small">IDDLEMAN AND</span> O<span class="small">THER</span> S<span class="small">TORIES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_halftit.vue?e3826ace